import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import AdminsListing from 'views/admin/conf-admins/AdminsListing'
import AdminsForm from 'views/admin/conf-admins/AdminsForm'

const Admins = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <AdminsListing />
      </Route>
      <Route path={`${path}/new`}>
        <AdminsForm />
      </Route>
      <Route path={`${path}/edit/:adminId`}>
        <AdminsForm />
      </Route>
    </Switch>
  )
}
export default Admins
